import { BlendShapeMapper } from "./BlendShapeMapper.js";
class ModelController {
  constructor() {
    this.blendShapeMapper = new BlendShapeMapper();
    this.currentModel = null;
  }

  /**
   * Initialize a loaded model
   * @param {Object} model - The loaded 3D model
   */
  initializeModel(model) {
    this.currentModel = model;
    // Get available phonemes for logging/debugging
    const availablePhonemes = this.blendShapeMapper.getAvailablePhonemes(
      Object.keys(model.morphTargetDictionary || {}),
    );
    console.log("Available phonemes for model:", availablePhonemes);
  }

  /**
   * Apply a phoneme to the current model
   * @param {String} phoneme - The standard phoneme to apply
   * @param {Number} weight - The weight/intensity of the blend shape
   */
  applyPhoneme(phoneme, weight = 1.0) {
    if (this.currentModel) {
      this.blendShapeMapper.applyPhonemeBlendShape(
        this.currentModel,
        phoneme,
        weight,
      );
    }
  }

  /**
   * Reset all blend shapes on the current model
   */
  resetBlendShapes() {
    if (this.currentModel) {
      this.blendShapeMapper.resetBlendShapes(this.currentModel);
    }
  }

  /**
   * Apply a sequence of phonemes with timing
   * @param {Array} sequence - Array of {phoneme, duration, weight} objects
   */
  async applyPhonemeSequence(sequence) {
    for (const { phoneme, duration, weight = 1.0 } of sequence) {
      this.applyPhoneme(phoneme, weight);
      await new Promise((resolve) => setTimeout(resolve, duration));
    }
    this.resetBlendShapes();
  }
}

export default ModelController;
